export const MULO_CONTAINER_WIDTH = {
  READING: 870,
  STANDARD: 960,
  WIDE: 1180,
};
